import {
    Component,
    EventEmitter,
    TemplateRef,
    Input,
    Output
} from '@angular/core';

@Component({
    selector: 'pm-combo-chart',
    //templateUrl: './app/controls/components/chart/combo-chart/combo-chart.html'
    templateUrl: './combo-chart.html',
})
export class ComboChartComponent {

}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/combo-chart/combo-chart-component.ts